import React, { useState, useEffect } from 'react';
import { BiPlus } from 'react-icons/bi';
import { CgClose } from 'react-icons/cg';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Form/Input';
import { RESUME_API_END_POINT } from "../../../../../utils/constant";
import axios from 'axios';
import Select from '../../../../../components/Form/Select';
import ComboBox from '../../../../../components/Form/Combobox';
import ButtonBlack from '../../../../../components/Buttons/ButtonBlack';
import { useSelector } from 'react-redux';
import { useOutletContext } from 'react-router-dom';

const Skills = ({data, setData}) => {
    const [showModal, setShowModal] = useState(false);
    const [skills, setSkills] = useState(data?.skills || []);
    const [newSkill, setNewSkill] = useState('');
    const [editingSkill, setEditingSkill] = useState(null);
    const [selectedValue, setSelectedValue] = useState("");
     const {user} = useSelector(store=>store.user)
    const {showNotif, setShowNotif} = useOutletContext()
    useEffect(() => {
        if (Array.isArray(data?.skills)) {
            setSkills(data.skills);
        } else {
            setSkills([]); // S'assurer que c'est toujours un tableau
        }
      }, [data]);

    // Edit an existing skill
    const editSkill = async (updatedSkills) => {
        try {
           
            // console.log("Data submitted", dataToSubmit);
    
            const response = await axios.post(`${RESUME_API_END_POINT}/skills/update/${user.id}`, { skills: updatedSkills });
    
            setShowNotif({ ...showNotif, variant: "success", message: response?.data?.message, show: true });
            setSkills(updatedSkills); // Met à jour l'état après la requête réussie
        } catch (error) {
            setShowNotif({ ...showNotif, variant: "danger", message: "Une erreur est survenue", show: true });
            console.log(error);
        }
    };
    
    // Delete skill
    // const deleteSkill = async (id) => {
    //         setSkills(skills.filter(skill => skill.id !== id));
    //     editSkill()
    // };

    const deleteSkill = async (skillToDelete) => {
        const updatedSkills = skills.filter((skill) => skill !== skillToDelete);
        // setSkills(updatedSkills);
        await editSkill(updatedSkills); // On passe la liste mise à jour
    };

    // Handle open modal for add/edit
    const handleOpenModal = (skill = null) => {
        setEditingSkill(skill);
        setNewSkill(skill ? skill.name : '');
        setShowModal(true);
    };


    return (
        <div className="flex-col text-start border p-4 rounded-md">
            <div className="flex justify-between items-center mb-4">
                <div className='font-semibold'>Compétences</div>
                <button onClick={() => handleOpenModal()} className="bg-neutral-50  border rounded-sm p-1">
                    <BiPlus className='w-5 h-5 text-neutral-500' />
                </button>
            </div>

           <div className="flex gap-4 w-full">
           <ComboBox
           selectedValue={selectedValue}
        values={["Argentina", "Brazil", "China", "USA", "Italy", "France"]}
        onChange={(value) => {
            setSelectedValue(value)            
        }}
      />
      <ButtonBlack onClick={()=>{
        if (selectedValue) {
            const updatedSkills = [...skills, selectedValue];
            // setSkills((prevSkills) => [...prevSkills, selectedValue]);
            editSkill(updatedSkills);
        }
        }}>Ajouter</ButtonBlack>
           </div>
           
       <p className="mt-4">Valeur sélectionnée : <strong>{selectedValue}</strong></p>
           
       <div className="flex gap-2 flex-wrap"> 
                {skills?.map((skill) => (
                    <div key={skill} className="py-2 pl-4 pr-3 text-primary-text bg-gray-50 flex gap-1 items-center border rounded-sm">
                        {skill}
                        <button onClick={() => deleteSkill(skill)} className='hover:bg-neutral-400 hover:text-white rounded-full p-0.5'>
                            <CgClose />
                        </button>
                        </div>
                ))}
            </div>

            
            {/* Modal for adding/editing skill */}
            <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
                <div className="flex items-center justify-between py-2 px-4">
                    <p>{editingSkill ? 'Modifier' : 'Ajouter'} une compétence</p>
                    <button onClick={() => setShowModal(false)} className='px-2 py-2 rounded-md border text-primary-black'>
                        <CgClose />
                    </button>
                </div>
                <hr className='mb-6' />
                <div className="px-6 space-y-4 mb-4">
                    <Select 
                    placeholder='Veuillez sélectionner une compétence'
                    options={["Figma"]}
                    label='Compétence' 
                    value={newSkill} 
                    onChange={(e) => setNewSkill(e.target.value)} 
                    />
                </div>
                <div className="flex items-center justify-end p-6">
                </div>
            </Modal>    
        </div>
    );
}

export default Skills;
